/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Maxim Fedorov
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.0.0
 */
import ICommonTranslationContextHelp from '../../types/common/contextHelp';

const initTranslationContextHelp: ICommonTranslationContextHelp = {
    account: '',
    accountInfo: '',
    bills: '',
    billsUnpaid: '',
    closeBtn: '',
    dashboard: '',
    expensesAnalyzerAccount: '',
    expensesAnalyzerAccountId: '',
    expensesAnalyzerBillsAccounts: '',
    expensesAnalyzerBillsSubscribers: '',
    expensesAnalyzerSubscribers: '',
    expensesAnalyzerSubscriberFixed: '',
    expensesAnalyzerSubscriberFixedId: '',
    expensesAnalyzerSubscriberMobile: '',
    expensesAnalyzerSubscriberMobileId: '',
    history: '',
    inquiries: '',
    inquiriesOther: '',
    inquiryInfo: '',
    link: '',
    offers: '',
    orders: '',
    reports: '',
    subscriberMobile: '',
    title: '',
    wizardMultiSearch: '',
    news: '',
    wizardAdditionalReportsFromAccountId: '',
    wizardAdditionalReportsFromAccounts: '',
    wizardAdditionalReportsFromSubscriberId: '',
    wizardAdditionalReportsFromSubscribers: '',
};

export default initTranslationContextHelp;
